import { useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Box, Typography } from "@mui/material";
import { ClassicEditor, getEditorConfig } from "./ckeditorConfig";

const RichTextEditor = ({
  value = "",
  onChange,
  placeholder = "",
  height = 400,
  id,
}) => {
  const [wordCount, setWordCount] = useState({ words: 0, chars: 0 });

  const updateWordCount = (editor) => {
    const text = editor.editing.view.document.getRoot()?.textContent ?? "";
    const words = text.trim() ? text.trim().split(/\s+/).length : 0;
    setWordCount({ words, chars: text.length });
  };

  const handleEditorChange = (_event, editor) => {
    updateWordCount(editor);
    onChange?.(editor.getData());
  };

  return (
    <Box id={id} className="rich-text-editor">
      <style>
        {`
          .rich-text-editor .ck-editor__editable {
            min-height: ${height - 100}px;
          }
          .rich-text-editor .ck-content .info-box {
            padding: 12px 16px;
            background: #e8f4fd;
            border-left: 4px solid #2196f3;
            border-radius: 4px;
          }
          .rich-text-editor .ck-content .warning-box {
            padding: 12px 16px;
            background: #fff8e1;
            border-left: 4px solid #ff9800;
            border-radius: 4px;
          }
          .rich-text-editor .ck-content .marker {
            background: #fff59d;
            padding: 0 4px;
          }
          .rich-text-editor .ck-content .text-small {
            font-size: 0.875em;
            color: #666;
          }
        `}
      </style>

      <Box
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          overflow: "hidden",
          "& .ck-toolbar": {
            border: "none !important",
            borderBottom: "1px solid",
            borderColor: "divider",
          },
          "& .ck-editor__editable": {
            border: "none !important",
            boxShadow: "none !important",
          },
        }}
      >
        <CKEditor
          editor={ClassicEditor}
          data={value}
          config={getEditorConfig(placeholder)}
          onReady={(editor) => updateWordCount(editor)}
          onChange={handleEditorChange}
        />
      </Box>

      {/* <Typography variant="caption" color="text.secondary" display="block" mt={1}>
        {wordCount.words} words · {wordCount.chars} characters
      </Typography> */}
    </Box>
  );
};

export default RichTextEditor;
